module.exports = __webpack_public_path__ + "img/p4.8e333064.png";